import React  from "react";
import { FormatMessage } from "react-globalize";
import Globalize from "globalize";

export function getBulletAndText(locale, targetClass, messagePath) {
  return [
  <span key="collapsedbullet" data-toggle="collapse" data-target={"." + targetClass} className={targetClass + " collapse collapseIcon iconOver"} role="button">
    <i className="fa fa-caret-up" ></i>
  </span>,
  <span key="openbullet" data-toggle="collapse" data-target={"." + targetClass} className=" collapseIcon iconUnder" role="button">
    <i className="fa fa-caret-right" style={{paddingLeft:1}}></i>
  </span>,
  messagePath === undefined ? "" 
  : <FormatMessage key="bulletmessage" locale={locale} path={messagePath} data-toggle="collapse" data-target={"." + targetClass} role="button" />
  ];
}

export function getListItems(locale, amount, messagePath, elements) {
  let result = [];
  for(let index = 0; index < amount; index++) {
    if (elements)
      result = [...result, <li><FormatMessage locale={locale} path={messagePath + "/" + index} elements={elements} /></li>]
    else
      result = [...result, <li><FormatMessage locale={locale} path={messagePath + "/" + index} /></li>]
  }
   return result;
}

export function getTableBodyRows(locale){
  let result = [];
  for(let index = 0; index < 7; index++) {
    result = [...result, 
    <tr>
      <td>
        <h5><FormatMessage locale={locale} path={"glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/reason/title"} /></h5>
        <p>{Globalize(locale).formatMessage("glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/reason/note").trim()}</p>
      </td>
      <td>
        <FormatMessage locale={locale} path={"glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/shared"} />
      </td>
      <td>
        <FormatMessage locale={locale} path={"glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/boundable"} />
      </td>
    </tr>
    ]
  }
  return result;
}


// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy/globalizationUtils.js